// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--BGKxk","text-secondary":"_9e1425b4d3--text-secondary--qjC5b","caption":"_9e1425b4d3--caption--ORf3v"};